import { render, staticRenderFns } from "./NewGate.vue?vue&type=template&id=4eded77c"
import script from "./NewGate.vue?vue&type=script&lang=js"
export * from "./NewGate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports